<template>
    <div class="">

        <!-- Single Image -->
        <div
            v-if="!multiple && images.length && images[0]['url'] != null"
            class="text-center"
        >
            <div class="d-inline-block position-relative fade-in">
                <img
                    :src="imageToShow"
                    class="rounded border border-secondary p-2 shadow-lg"
                    style="width: 100px; height: 100px; object-fit: cover;"
                />

                <b-button
                    variant="danger"
                    size="sm"
                    class="remove-button"
                    @click="removeImage(0)"
                >
                    <i class="mdi mdi-close"></i>
                </b-button>
            </div>
        </div>

        <!-- Multiple Images -->
        <div
            v-if="multiple && images.length"
            class="d-flex flex-wrap justify-content-center"
        >
            <div
                v-for="(image, index) in images"
                :key="index"
                class="position-relative mr-3 mb-3 fade-in"
            >
                <img
                    :src="image.url"
                    class="rounded border border-secondary p-2 shadow-lg"
                    style="width: 100px; height: 100px; object-fit: cover;"
                />

                <b-button
                    variant="danger"
                    size="sm"
                    class="remove-button"
                    @click="removeImage(index)"
                >
                    <i class="mdi mdi-close"></i>
                </b-button>
            </div>
        </div>

        <!-- Upload Button -->
        <div
            v-if="images.length == 0 || multiple"
            class="text-center fade-in"
        >
            <b-button
                variant="outline-info"
				size="sm"
                @click="triggerFileInput"
            >
                <i class="mdi mdi-image-plus mr-1"></i>
                {{ buttonText }}
            </b-button>
        </div>

        <input
            type="file"
            ref="fileInput"
            @change="onFileChange"
            :multiple="multiple"
            accept="image/*"
            style="display: none;"
        />

    </div>
</template>
<script>
export default {
    props: {
        multiple: {
            type: Boolean,
            default: false,
        },
        buttonText: {
            type: String,
            default: 'Upload Image', // Default button text
        },
        initialImages: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            images: [],
            defaultImageUrl: 'https://getbase.s3.ap-southeast-1.amazonaws.com/default_profile_image.jpg',
        };
    },
    computed: {
        imageToShow() {
            if (this.images.length) {
                return this.images[0].url;
            } else if (this.initialImages && this.initialImages.length > 0) {
                return this.initialImages[0];
            } else {
                return this.defaultImageUrl;
            }
        },
    },
    watch: {
        initialImages: {
            immediate: true,
            handler(newVal) {
                // Initialize the internal images array from initialImages only if it’s currently empty,
                // preventing overwriting any user-uploaded images while ensuring initial data is loaded.
                if (!this.images.length && newVal.length)
                    this.images = newVal.map((url) => ({ url }));
            },
        },
    },
    methods: {
        triggerFileInput() {
            this.$refs.fileInput.click();
        },
        onFileChange(event) {
            const files = event.target.files;
            if (!files.length) return;

            if (!this.multiple) {
                this.images = [];
            }

            for (let i = 0; i < files.length; i++) {
                const file = files[i];
                const reader = new FileReader();

                reader.onload = (e) => {
                    if (this.multiple) {
                        this.images.push({ file, url: e.target.result });
                    } else {
                        this.images = [{ file, url: e.target.result }];
                    }
                    this.$emit('images-changed', [...this.images]);
                };

                reader.readAsDataURL(file);
            }

            // ✅ Reset input so the same file can be uploaded again later
            this.$refs.fileInput.value = '';
        },
        removeImage(index) {
            const removed = this.images[index]; // 包含 uuid 和 url
            this.images.splice(index, 1);

            this.$emit('images-removed', removed); // ⬅ 发整个对象而不是 index
            this.$emit('images-changed', [...this.images]);
            // ✅ Reset input so user can reupload same image
            this.$refs.fileInput.value = '';
        },
        
        clear() {
            this.images = [];
            if (this.$refs.fileInput) this.$refs.fileInput.value = '';
            this.$emit('images-changed', []);
            this.$emit('images-removed', null); // optional signal
        }
    }
};
</script>
<style scoped>
	.remove-button {
		position: absolute;
		top: -8px;
		right: -8px;
		border-radius: 50%;
		padding: 2px 6px;
	}
</style>
